import { atom } from "recoil";

export const actionProfitLists = atom({
  key: "actionProfitLists",
  default: null,
});
